/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify,
 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthConfigurationService } from '../views/auth/auth-configuration.service';
import { AuthService } from '../views/auth/auth.service';
import { navItems } from '../_nav';
//27/12/2022
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { navMobItems } from '../navmobile';
import { navAdmin } from '../navigationAdmin';
import { PaymentService } from '../payment/payment.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  public navMobItems=navMobItems;
  public navAdmin=navAdmin;
  public role : String; 
  
  isAuthenticated$: Observable<Boolean>;
  email$: string;
  title = 'appBootstrap';
  closeResult: string;
  neversubscribed=false;
  constructor(private authService :AuthService,private PayService:PaymentService,
              public router: Router,private modalService: NgbModal) {}

  ngOnInit() {


    this.email$ = localStorage.getItem('email')
    this.role=localStorage.getItem('Role');
    window.onbeforeunload = function (event) {
      var message = 'Important: Please click on \'Save\' button to leave this page.';
      if (typeof event == 'undefined') {
          event = window.event;
      }
      if (event) {
          event.returnValue = message;
      }
      return message;
  };
  
  this.PayService.getActualSubByEmail(localStorage.getItem('email')).subscribe(
    datas =>{
console.log ("here");
    },
    error => {
     
console.log(error);
if (error.status ==401) {
this.neversubscribed=true
}
     }
  );


  

  }
  


  
  logout(content):void {
    //27/12/2022
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
signout():void{
    this.authService.logout(this.email$).subscribe(
      data => {

      localStorage.setItem('token', '')
      localStorage.setItem('email','')
      this.router.navigate(['/']);

     


      },
      error => {
        console.log(error, 'error')
        if (error.status == 404) {
         
        }
        else if (error.status == 401) {
          
        }

      }
    );
    
}
toggleMinimize(e) {
    this.sidebarMinimized = e;
  }



Gotoprofile(){
  this.router.navigate(['/Profile/profile']);
}
GotoprofileSecurity(){
  this.router.navigate(['profilesecurity/profilesecurity']);
}
GotoSupport(){
  this.router.navigate(['support/support']);
}
GotoAbonnement(){
  this.router.navigate(['accountbilling/accountbilling']);
}
}
